import { useLocation } from "react-router-dom";
import { LocalizedLink } from "@/i18n/LocalizedLink";
import { useLang } from "@/i18n/LangContext";
import { Gamepad2, Github, Twitter, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <footer className="border-t border-white/10 mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-brand to-brand-cyan flex items-center justify-center">
              <Gamepad2 className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-heading font-bold text-lg">KHA GAMES</div>
              <div className="text-xs uppercase tracking-[0.2em] text-brand-cyan/80">{t("tagline")}</div>
            </div>
          </div>
          <p className="text-zinc-400 text-sm max-w-md leading-relaxed">
            {t("hero.subtitle")}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3 font-bold">{t("nav.home")}</div>
          <ul className="space-y-2 text-sm">
            <li><LocalizedLink to="/games" className="text-zinc-400 hover:text-white">{t("nav.games")}</LocalizedLink></li>
            <li><LocalizedLink to="/verify" className="text-zinc-400 hover:text-white">{t("nav.verify")}</LocalizedLink></li>
            <li><LocalizedLink to="/faq" className="text-zinc-400 hover:text-white">{t("nav.faq")}</LocalizedLink></li>
            <li><LocalizedLink to="/contact" className="text-zinc-400 hover:text-white">{t("nav.contact")}</LocalizedLink></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3 font-bold">Connect</div>
          <div className="flex gap-3">
            <a href="#" className="text-zinc-400 hover:text-brand-cyan"><Twitter className="w-5 h-5" /></a>
            <a href="#" className="text-zinc-400 hover:text-brand-cyan"><Github className="w-5 h-5" /></a>
            <a href="#" className="text-zinc-400 hover:text-brand-cyan"><Mail className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} KHA GAMES. All rights reserved.
      </div>
    </footer>
  );
}
